import { apiClient } from '@/config/api';
import { Attribute, HydraCollection } from '@/types';

export const attributeService = {
  // Get attributes by project
  async getAttributesByProject(projectId: number): Promise<Attribute[]> {
    const response = await apiClient.get<HydraCollection<Attribute>>('/attributes', {
      params: {
        'groups[]': ['attribute:read'],
        'project': `/api/projects/${projectId}`,
      },
    });

    const data = response.data;
    return data['hydra:member'] || data['member'] || [];
  },

  // Get attributes by device (using dedicated endpoint for better performance)
  async getAttributesByDevice(deviceId: number): Promise<Attribute[]> {
    const response = await apiClient.get<Attribute[]>(`/devices/${deviceId}/attributes`);
    return response.data;
  },

  // Get single attribute by ID
  async getAttribute(id: number): Promise<Attribute> {
    const response = await apiClient.get<Attribute>(`/attributes/${id}`);
    return response.data;
  },

  // Create attribute
  async createAttribute(data: Partial<Attribute>): Promise<Attribute> {
    const response = await apiClient.post('/attributes', data);
    return response.data;
  },

  // Update attribute
  async updateAttribute(id: number, data: Partial<Attribute>): Promise<Attribute> {
    const response = await apiClient.put(`/attributes/${id}`, data);
    return response.data;
  },

  // Delete attribute
  async deleteAttribute(id: number): Promise<void> {
    await apiClient.delete(`/attributes/${id}`);
  },

  // Associate attribute with area
  async associateAttributeWithArea(attributeId: number, areaId: number): Promise<void> {
    await apiClient.post(`/attributes/${attributeId}/areas/${areaId}`);
  },

  // Disassociate attribute from area
  async disassociateAttributeFromArea(attributeId: number, areaId: number): Promise<void> {
    await apiClient.delete(`/attributes/${attributeId}/areas/${areaId}`);
  },
};
